var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/sections/announcement-bar.js
import { timeline } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { EffectCarousel } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var AnnouncementBar = class extends EffectCarousel {
  _transitionTo(fromSlide, toSlide) {
    timeline([
      [fromSlide, { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }],
      [toSlide, { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    this._parentSection = this.closest(".shopify-section");
    this._dragging = false;
    this._offsetX = this._currentX = 0;
    this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
    this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
    this._recalculateOffset();
    window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    if (event.target === this || this.contains(event.target)) {
      this._initialX = event.clientX - this._offsetX;
      this._dragging = true;
    }
  }
  _onPointerMove(event) {
    if (!this._dragging) {
      return;
    }
    this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
    this._offsetX = this._currentX;
    this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
  }
  _onPointerUp() {
    this._dragging = false;
  }
  _recalculateOffset() {
    this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
  }
};
if (!window.customElements.get("split-cursor")) {
  window.customElements.define("split-cursor", SplitCursor);
}

// js/sections/collection-list.js
import { timeline as timeline2, inView } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var CollectionList = class extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, this._reveal.bind(this), { margin: "-100px" });
    }
  }
  _reveal() {
    const toReveal = Array.from(this.querySelectorAll("[reveal-js]"));
    timeline2([
      [toReveal, { opacity: 1 }, { duration: 0 }],
      [toReveal.map((item) => item.querySelector("img, svg")), { opacity: [0, 1], transform: ["scale(1.03)", "auto"] }, { duration: 0.2 }],
      [toReveal.map((item) => item.querySelector(".collection-card__content-wrapper")), { opacity: [0, 1] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("collection-list")) {
  window.customElements.define("collection-list", CollectionList);
}

// js/sections/customer-login.js
import { Delegate } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var AccountLogin = class extends HTMLElement {
  connectedCallback() {
    this.recoverForm = this.querySelector("#recover");
    this.loginForm = this.querySelector("#login");
    if (window.location.hash === "#recover") {
      this._switchForms();
    }
    new Delegate(this).on("click", '[href="#recover"], [href="#login"]', this._switchForms.bind(this));
  }
  _switchForms(event) {
    if (event) {
      event.preventDefault();
    }
    this.recoverForm.hidden = !this.recoverForm.hidden;
    this.loginForm.hidden = !this.loginForm.hidden;
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}

// js/sections/header.js
import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { AnimatedDetails, EffectCarousel as EffectCarousel2, Drawer, throttle } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var reduceMenuAnimation = JSON.parse("true");
var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute("hide-on-scroll") && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._hasSwitchedToSticky = false;
      window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    }
    this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: true });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.classList.remove("is-filled");
        this._setupTransparentHeader();
      }
    });
    this._setupTransparentHeader();
    if (this.hasAttribute("sticky")) {
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this));
      }
    }
  }
  hide() {
    if (this._isVisible) {
      animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.2, easing: "ease" });
      this._isVisible = false;
    }
  }
  show() {
    if (!this._isVisible) {
      animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease" });
      this._accumulatedScroll = 0;
      this._isVisible = true;
    }
  }
  _onScroll() {
    if (window.scrollY < 0) {
      return;
    }
    this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop));
    if (window.scrollY < this._lastScrollTop) {
      this.show();
    } else if (this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll"))) {
      this.hide();
    }
    this._lastScrollTop = window.scrollY;
  }
  _checkTransparency() {
    let hasFallbackScrollDetection = false;
    if (CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")) {
      const offsetBeforeChanging = 500;
      if (this.querySelectorAll("[open]").length > 0) {
        this.classList.add("is-filled");
      } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" });
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || hasFallbackScrollDetection);
    }
  }
  _setupTransparentHeader() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
      this.setAttribute("allow-transparency", "");
      this.addEventListener("mouseenter", this._checkTransparency.bind(this));
      this.addEventListener("mouseleave", this._checkTransparency.bind(this));
      if (this.hasAttribute("sticky")) {
        window.addEventListener("scroll", throttle(this._checkTransparency.bind(this)));
      }
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
var DropdownDisclosure = class _DropdownDisclosure extends AnimatedDetails {
  constructor() {
    super();
    this._detectClickOutsideListener = this._detectClickOutside.bind(this);
    this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this);
    this._detectFocusOutListener = this._detectFocusOut.bind(this);
    this._detectHoverListener = this._detectHover.bind(this);
    this._hoverTimer = null;
    this.addEventListener("mouseover", this._detectHoverListener.bind(this));
    this.addEventListener("mouseout", this._detectHoverListener.bind(this));
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  /**
   * When the summary is clicked and that the mode is hover, we follow the link (if set) that may have been specified
   * on the parent. If the mode is click, then we deferred to the default behavior of the "AnimatedDetails" parent
   */
  _onSummaryClicked(event) {
    if (this.trigger === "hover") {
      event.preventDefault();
      if (event.currentTarget.hasAttribute("data-url")) {
        window.location.href = event.currentTarget.getAttribute("data-url");
      }
    } else {
      super._onSummaryClicked(event);
    }
  }
  async _transition(value) {
    if (value) {
      this.setAttribute("open", "");
      document.addEventListener("click", this._detectClickOutsideListener);
      document.addEventListener("keydown", this._detectEscKeyboardListener);
      document.addEventListener("focusout", this._detectFocusOutListener);
      const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
      openSiblings.forEach((sibling) => sibling.open = false);
      await this._transitionIn(openSiblings.length > 0);
    } else {
      document.removeEventListener("click", this._detectClickOutsideListener);
      document.removeEventListener("keydown", this._detectEscKeyboardListener);
      document.removeEventListener("focusout", this._detectFocusOutListener);
      await this._transitionOut();
      this.removeAttribute("open");
    }
  }
  _transitionIn(hasOpenSiblings = false) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      timelineSequence.push([this.contentElement.querySelectorAll(":scope > ul > li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { delay: stagger(0.025), at: "-0.1", duration: 0.2 }]);
    }
    return timeline3(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 }).finished;
  }
  _transitionOut() {
    return timeline3([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
  }
  /**
   * When dropdown menu is configured to open on click, we add a listener to detect click outside and automatically
   * close the navigation.
   */
  _detectClickOutside(event) {
    if (this.trigger !== "click") {
      return;
    }
    if (!this.contains(event.target) && !(event.target.closest("details") instanceof _DropdownDisclosure)) {
      this.open = false;
    }
  }
  /**
   * On desktop device, if the mode is set to hover, we open/close the dropdown on hover
   */
  _detectHover(event) {
    if (this.trigger !== "hover") {
      return;
    }
    if (event.type === "mouseover") {
      this.open = true;
      clearTimeout(this._hoverTimer);
    } else {
      this._hoverTimer = setTimeout(() => this.open = false, this.mouseOverDelayTolerance);
    }
  }
  /**
   * Detect if we hit the "Escape" key to automatically close the dropdown
   */
  _detectEscKeyboard(event) {
    if (event.code === "Escape") {
      const targetMenu = event.target.closest("details[open]");
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }
  /**
   * Close the dropdown automatically when the dropdown is focused out
   */
  _detectFocusOut(event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.open = false;
    }
  }
};
var MegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
  }
  get mouseOverDelayTolerance() {
    return 500;
  }
  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"], contentDelay = hasOpenSiblings ? 0.1 : 0;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".mega-menu__promo").forEach((promo) => {
        timelineSequence.push([promo, { opacity: [0, 1] }, { duration: 0.25, delay: contentDelay, at: "mega-menu" }], "mega-menu-promo");
      });
      this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((column) => {
        timelineSequence.push([column.querySelectorAll(":scope > :first-child, :scope li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", delay: stagger(0.025, { start: contentDelay }), at: "mega-menu", duration: 0.2 }]);
      });
    }
    return timeline3(timelineSequence).finished;
  }
  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};
var MegaMenuPromoCarousel = class extends EffectCarousel2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.nextElementSibling) {
      this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
    }
    this._updateControlsColor(this.items[this.selectedIndex]);
  }
  _updateControlsColor(slide) {
    if (!slide?.classList) return;
    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;
    this?.nextElementSibling?.style?.setProperty("--text-color", extractFrom?.style?.getPropertyValue("--text-color"));
  }
};
var NavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate2(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }
  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }
  // Used for navigation mobile and navigation desktop set to drawer
  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );
    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    timeline3(timelineSequence);
  }
  // Used when mega menu is set to drawer
  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]);
    }
    timeline3(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline3([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }
  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) }];
  }
  // Set navigation drawer to initial state when drawer closed
  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }
    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }
  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }
  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}
if (!window.customElements.get("dropdown-disclosure")) {
  window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-disclosure")) {
  window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}
if (!window.customElements.get("navigation-drawer")) {
  window.customElements.define("navigation-drawer", NavigationDrawer);
}

// js/sections/feature-chart.js
import { animate as motionAnimate, scroll } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var FeatureChart = class extends HTMLElement {
  connectedCallback() {
    this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]');
    this.featureChartTable = this.querySelector(".feature-chart__table");
    this.featureChartRows = Array.from(this.featureChartTable.childNodes);
    this.featureProductRow = this.querySelector(".feature-chart__table-row--product");
    this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky");
    if (this.viewButtonElement) {
      this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
    }
    if (this.featureChartSticky) {
      this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`;
      this.featureChartTable.addEventListener("scroll", (event) => {
        this.featureChartSticky.style.marginLeft = -1 * event.target.scrollLeft + "px";
      });
      new ResizeObserver((entries) => {
        this.featureChartSticky.style.width = `${entries[0].contentRect.width}px`;
      }).observe(this.featureChartTable);
      const offset = getComputedStyle(this).scrollPaddingTop;
      scroll(({ y }) => {
        if (y.current >= y.targetOffset + this.featureProductRow.clientHeight / 2 && y.progress < 0.85) {
          this.featureChartSticky.classList.add("is-visible");
        } else {
          this.featureChartSticky.classList.remove("is-visible");
        }
      }, {
        target: this.featureChartTable,
        offset: [`${offset} start`, `end ${offset}`]
      });
    }
  }
  _toggleRows() {
    if (this.classList.contains("is-expanded")) {
      this._hideRows();
    } else {
      this._showRows();
    }
  }
  async _showRows() {
    const fromHeight = this.featureChartTable.clientHeight;
    this.featureChartRows.forEach((row) => {
      row.hidden = false;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-less");
    this.classList.add("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${this.featureChartTable.clientHeight}px`] }).finished;
    this.featureChartTable.style.height = "auto";
  }
  async _hideRows() {
    let fromHeight = this.featureChartTable.clientHeight, toHeight = 0;
    this.featureChartRows.slice(0, parseInt(this.getAttribute("max-rows"))).forEach((row) => {
      toHeight += row.clientHeight;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-more");
    this.classList.remove("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${toHeight}px`] }).finished;
    this.featureChartRows.slice(parseInt(this.getAttribute("max-rows"))).forEach((row) => row.hidden = true);
    this.featureChartTable.style.height = "auto";
  }
};
if (!window.customElements.get("feature-chart")) {
  window.customElements.define("feature-chart", FeatureChart);
}

// js/sections/image-banner.js
import { scroll as scroll2, timeline as timeline4, animate as animate2, inView as inView2 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { imageLoaded, getHeadingKeyframe } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var ImageBanner = class extends HTMLElement {
  connectedCallback() {
    if (this.parallax && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._setupParallax();
    }
    inView2(this, async () => {
      await imageLoaded(Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")));
      const headings = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
      timeline4([
        [this, { opacity: [0, 1] }, { duration: 0.25 }],
        ...headings.map((heading) => [...getHeadingKeyframe(heading)])
      ]);
    });
  }
  get parallax() {
    return this.hasAttribute("parallax") ? parseFloat(this.getAttribute("parallax")) : false;
  }
  _setupParallax() {
    const media = Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")), [scale, translate] = [1 + this.parallax, this.parallax * 100 / (1 + this.parallax)];
    scroll2(
      animate2(media, { transform: [`scale(${scale}) translateY(${translate}%)`, `scale(${scale}) translateY(0)`] }, { easing: "linear" }),
      {
        target: this,
        offset: ["start end", "end start"]
      }
    );
  }
};
if (!window.customElements.get("image-banner")) {
  window.customElements.define("image-banner", ImageBanner);
}

// js/sections/image-link-blocks.js
import { ScrollArea } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var ImageLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    new ScrollArea(this);
    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);
  }
  _prev() {
    this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _next() {
    this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
  }
};
if (!window.customElements.get("image-link-blocks")) {
  window.customElements.define("image-link-blocks", ImageLinkBlocks);
}

// js/sections/images-with-text-scrolling.js
import { animate as animate3, timeline as timeline5, inView as inView3 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { getHeadingKeyframe as getHeadingKeyframe2, throttle as throttle2 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    inView3(this, this._reveal.bind(this));
    if (this.hasAttribute("scrolling-experience")) {
      this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"));
      this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child");
      this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"));
      if (this._imageToTransitionItems.length > 0) {
        window.addEventListener("scroll", throttle2(this._onScroll.bind(this)));
      }
    }
  }
  _reveal() {
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((heading) => {
      animate3(...getHeadingKeyframe2(heading));
    });
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(), imageBottom = imageRect.bottom, imageEffect = this.getAttribute("scrolling-experience");
    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect(), image = this._imageToTransitionItems[index - 1], content = this._contentItems[index];
      if (contentItemRect.top < imageBottom - imageRect.height * 0.15 && contentItemRect.bottom > imageBottom) {
        if (image && !image.classList.contains("is-visible")) {
          image.classList.add("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 1] }, { duration: 0.2 }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          }
        }
        break;
      }
      if (contentItemRect.top > imageBottom - imageRect.height * 0.15) {
        if (image && image.classList.contains("is-visible")) {
          image.classList.remove("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 0] }, { duration: 0.2 }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          }
        }
        break;
      }
    }
  }
};
if (!window.customElements.get("images-with-text-scrolling")) {
  window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
}

// js/sections/impact-text.js
import { animate as animate4, inView as inView4 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var ImpactText = class extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      return;
    }
    inView4(this, ({ target }) => this._onBecameVisible(target), { margin: "-100px" });
  }
  async _onBecameVisible(target) {
    animate4(target, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 });
    if (this.hasAttribute("count-up")) {
      const itemToSearch = this.childElementCount === 0 ? this : this.firstElementChild, matches = itemToSearch.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
      if (!matches) {
        return;
      }
      itemToSearch.innerHTML = itemToSearch.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${matches[0]}</span>`);
      const numberSpan = itemToSearch.querySelector("span");
      numberSpan.style.textAlign = matches[0] === matches["input"] ? null : "end";
      if (!itemToSearch.classList.contains("text-gradient")) {
        numberSpan.style.display = "inline-block";
        numberSpan.style.minWidth = `${numberSpan.clientWidth}px`;
      }
      const toReplace = matches[0].replace(/[,\. ]+/, ""), charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
      await animate4((progress) => {
        let formattedString = Math.round(progress * parseInt(toReplace)).toString();
        charactersMatches.forEach((character) => {
          if (formattedString.length >= matches[0].length - character.index) {
            formattedString = formattedString.slice(0, character.index) + character[0] + formattedString.slice(character.index);
          }
        });
        numberSpan.textContent = progress === 1 ? matches[0] : formattedString;
      }, { duration: parseFloat(this.getAttribute("count-up")), easing: [0.16, 1, 0.3, 1] }).finished;
      numberSpan.style.minWidth = null;
    }
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

// js/sections/media-grid.js
import { timeline as timeline6, inView as inView5 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var MediaGrid = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, this._onBecameVisible.bind(this));
    }
  }
  _onBecameVisible() {
    const contentElements = this.querySelectorAll(".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)");
    timeline6([
      [this.items, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }],
      [contentElements, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }]
    ]);
  }
};
if (!window.customElements.get("media-grid")) {
  window.customElements.define("media-grid", MediaGrid);
}

// js/sections/media-with-text.js
import { animate as animate5, timeline as timeline7, inView as inView6 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { imageLoaded as imageLoaded2 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var MediaWithText = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".media-with-text__item")).forEach((item) => {
        inView6(item, (observer) => this.reveal(observer.target));
      });
    }
  }
  reveal(item) {
    const media = item.querySelector(".media-with-text__media");
    imageLoaded2(media.querySelector("img")).then(() => {
      timeline7([
        [media, { opacity: [0, 1] }, { duration: 0.3 }],
        [media.querySelector("img, video-media"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
    animate5(item.querySelector(".media-with-text__content > .prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
  }
};
if (!window.customElements.get("media-with-text")) {
  window.customElements.define("media-with-text", MediaWithText);
}

// js/sections/multiple-images-with-text.js
import { timeline as timeline8, animate as animate6, stagger as stagger2, inView as inView7 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { EffectCarousel as EffectCarousel3, imageLoaded as imageLoaded3, getHeadingKeyframe as getHeadingKeyframe3 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var MultipleImagesWithText = class extends HTMLElement {
  constructor() {
    super();
    this._imageCarousel = this.querySelector("multiple-images-with-text-image-list");
    this._contentCarousel = this.querySelector("multiple-images-with-text-content-list");
    this.addEventListener("control:prev", () => {
      this._imageCarousel.previous();
      this._contentCarousel.previous();
    });
    this.addEventListener("control:next", () => {
      this._imageCarousel.next();
      this._contentCarousel.next();
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        if (event.target.hasAttribute("image-id")) {
          this._imageCarousel.select(this._imageCarousel.items.findIndex((item) => item.id === event.target.getAttribute("image-id")));
        }
      });
    }
  }
};
var MultipleImagesWithTextImageList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  async _reveal() {
    await imageLoaded3(this.querySelectorAll("img"));
    if (this.getAttribute("layout") === "stacked") {
      timeline8([
        [this.lastElementChild, { transform: "rotate(0deg)" }],
        [this.lastElementChild?.previousElementSibling, { transform: "rotate(2deg)" }, { at: "<" }],
        [this.lastElementChild?.previousElementSibling?.previousElementSibling, { transform: "rotate(-2deg)" }, { at: "<" }]
      ], {
        defaultOptions: { duration: 0.15, easing: [0.26, 0.02, 0.27, 0.97] }
      });
    } else if (this.getAttribute("layout") === "collage") {
      timeline8([
        [this.children, { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    } else {
      timeline8([
        [this.children, { opacity: 1, transform: "rotate(var(--image-rotation, 0deg))" }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    }
  }
  _transitionTo(fromSlide, toSlide, { direction, animate: animate8 }) {
    if (this.getAttribute("layout") !== "stacked") {
      return;
    }
    const transitionSpeed = 0.2;
    if (direction === "next") {
      const fromSlideTransform = getComputedStyle(fromSlide).getPropertyValue("transform");
      return timeline8([
        [fromSlide, { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" }, { duration: transitionSpeed }],
        [toSlide, { zIndex: 1 }, { duration: transitionSpeed, zIndex: { easing: "step-start" } }],
        [fromSlide, { opacity: 1, transform: fromSlideTransform, zIndex: -1 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }],
        [toSlide.previousElementSibling, { zIndex: 0 }, { at: "<", easing: "step-start" }]
      ], { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    } else {
      const toSlideTransform = getComputedStyle(toSlide).getPropertyValue("transform");
      return timeline8([
        [toSlide, { opacity: 0, transform: "rotate(-5deg) translate(-40px, -10px)" }, { duration: transitionSpeed }],
        this.items.length >= 3 && [fromSlide.previousElementSibling || this.lastElementChild, { zIndex: -1 }, { easing: "step-start" }],
        [toSlide, { opacity: 1, transform: toSlideTransform, zIndex: 1 }, { duration: transitionSpeed, at: this.items.length >= 3 ? "<" : "+0", zIndex: { easing: "step-start" } }],
        [fromSlide, { zIndex: 0 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }]
      ].filter(Boolean), { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    }
  }
};
var MultipleImagesWithTextContentList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  _reveal() {
    animate6(...getHeadingKeyframe3(this.querySelector('[reveal-on-scroll="true"]')));
  }
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    return timeline8([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
      [...getHeadingKeyframe3(toSlide.querySelector('[reveal-on-scroll="true"]'), { at: "<" })]
    ], { duration: animate8 ? parseFloat(this.getAttribute("fade-speed") || 0.5) : 0 }).finished;
  }
};
if (!window.customElements.get("multiple-images-with-text")) {
  window.customElements.define("multiple-images-with-text", MultipleImagesWithText);
}
if (!window.customElements.get("multiple-images-with-text-image-list")) {
  window.customElements.define("multiple-images-with-text-image-list", MultipleImagesWithTextImageList);
}
if (!window.customElements.get("multiple-images-with-text-content-list")) {
  window.customElements.define("multiple-images-with-text-content-list", MultipleImagesWithTextContentList);
}

// js/sections/newsletter-popup.js
import { Drawer as Drawer2 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var NewsletterPopup = class extends Drawer2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get initialFocus() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(localStorage.getItem("theme:popup-filled") === "true" || this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true");
  }
  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}

// js/sections/press.js
import { timeline as timeline9, animate as animate7, inView as inView8 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { EffectCarousel as EffectCarousel4 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var PressCarousel = class extends EffectCarousel4 {
  constructor() {
    super();
    if (reduceMotion2) {
      inView8(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate7(this.selectedSlide.querySelector(".blockquote"), { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2 });
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    await timeline9([
      [fromSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [null, 0] }, { duration: 0.2 }],
      [fromSlide.querySelector(".blockquote"), { opacity: [null, 0], ...reduceMotion2 && { transform: [null, "translateY(-10px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline9([
      [toSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [0, 1] }, { duration: 0.2 }],
      [toSlide.querySelector(".blockquote"), { opacity: [0, 1], ...reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
  }
};
if (!window.customElements.get("press-carousel")) {
  window.customElements.define("press-carousel", PressCarousel);
}

// js/sections/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    this._loadRecommendations();
  }
  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._isLoaded = true;
    const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${section.id.replace("shopify-section-", "")}&intent=${intent}`, response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations");
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    } else {
      if (intent === "related") {
        section.remove();
      } else {
        this.remove();
      }
    }
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

// js/sections/recently-viewed-products.js
import { extractSectionId } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
    } else {
      __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
  }
};
_isLoaded = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// js/sections/revealed-image-on-scroll.js
import { scroll as scroll3, timeline as timeline10, ScrollOffset, inView as inView9 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
var RevealedImage = class extends HTMLElement {
  connectedCallback() {
    const scrollTracker = this.querySelector(".revealed-image__scroll-tracker"), scroller = this.querySelector(".revealed-image__scroller");
    scrollTracker.style.height = `${scroller.clientHeight}px`;
    new ResizeObserver((entries) => scrollTracker.style.height = `${entries[0].contentRect.height}px`).observe(scroller);
    scroll3(timeline10([
      [this.querySelectorAll(".revealed-image__image-clipper, .revealed-image__content--inside"), { clipPath: ["inset(37% 37% 41% 37%)", "inset(calc(var(--sticky-area-height) / 2) 0)"] }, { easing: "ease-in" }],
      [this.querySelectorAll("img, svg"), { transform: ["translate(-10%, -1.5%) scale(1.4)", "translate(0, 0) scale(1)"] }, { easing: "ease-in", at: "<" }],
      [this.querySelectorAll(".revealed-image__content"), { opacity: [0, 1, 1] }, { offset: [0, 0.25, 1], at: "<" }]
    ]), {
      target: scrollTracker,
      offset: ScrollOffset.All
    });
    inView9(this, () => {
      this.style.visibility = "visible";
      return () => {
        this.style.visibility = "hidden";
      };
    }, { margin: "200px" });
  }
};
if (!window.customElements.get("revealed-image")) {
  window.customElements.define("revealed-image", RevealedImage);
}

// js/sections/shop-the-look.js
var ShopTheLookDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    Array.from(this.children).forEach((dots) => {
      document.getElementById(dots.getAttribute("aria-controls")).addEventListener("carousel:change", (event) => this._onDotClicked(event), { signal: this._abortController.signal });
    });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  _onDotClicked(event) {
    Array.from(this.querySelectorAll(`button:nth-child(${event.detail.index + 1})`)).forEach((button) => button.click());
  }
};
if (!window.customElements.get("shop-the-look-dots")) {
  window.customElements.define("shop-the-look-dots", ShopTheLookDots);
}

// js/sections/slideshow.js
import { animate as motionAnimate2, timeline as timeline11, inView as inView10 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { EffectCarousel as EffectCarousel5, imageLoaded as imageLoaded4, getHeadingKeyframe as getHeadingKeyframe4 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var Slideshow = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("carousel:select", this._onSlideSelected);
  }
  async _onSlideSelected(event) {
    const slideStyles = getComputedStyle(event.detail.slide);
    this.style.setProperty("--slideshow-controls-background", slideStyles.getPropertyValue("--slideshow-slide-controls-background"));
    this.style.setProperty("--slideshow-controls-color", slideStyles.getPropertyValue("--slideshow-slide-controls-color"));
    if (!this.classList.contains("slideshow--boxed")) {
      return;
    }
    const backgroundElement = this.querySelector(".slideshow__slide-background");
    const background = slideStyles.getPropertyValue("--slideshow-slide-background");
    backgroundElement.style.background = background;
    await motionAnimate2(backgroundElement, { opacity: [0, 1] }, { duration: 0.2 }).finished;
    this.style.setProperty("--slideshow-background", background);
    motionAnimate2(backgroundElement, { opacity: 0 }, { duration: 0 });
  }
};
var SlideshowCarousel = class extends EffectCarousel5 {
  constructor() {
    super();
    inView10(this, this._reveal.bind(this));
    if (this.querySelector(".slideshow__cursor")) {
      this.addEventListener("tap", this._onSlideshowTap);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (this._player && this.hasAttribute("autoplay")) {
      this._player.addEventListener("player:start", () => {
        const cursorRing = this.querySelector(".slideshow__cursor-ring circle");
        if (cursorRing) {
          motionAnimate2(cursorRing, { strokeDasharray: [`0px, ${cursorRing.getTotalLength()}px`, `${cursorRing.getTotalLength()}px, ${cursorRing.getTotalLength()}px`] }, {
            duration: parseInt(this.getAttribute("autoplay")),
            easing: "linear"
          });
        }
        const circles = Array.from(this.querySelectorAll(".numbered-dots__item"));
        circles.forEach((item) => {
          const circle = item.querySelector("circle:last-child");
          if (item.getAttribute("aria-current") === "true") {
            motionAnimate2(circle, { strokeDasharray: [`0px, ${circle.getTotalLength()}px`, `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`] }, { duration: parseInt(this.getAttribute("autoplay")), easing: "linear" });
          } else {
            motionAnimate2(circle, { strokeDasharray: `${circle.getTotalLength()}px, ${circle.getTotalLength()}px` }, { duration: 0, easing: "linear" });
          }
        });
      });
    }
  }
  get transitionType() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "fade" : this.getAttribute("transition");
  }
  async _reveal() {
    const selectedSlide = this.selectedSlide;
    await imageLoaded4(selectedSlide.querySelectorAll("img"));
    this.style.opacity = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if (!this._reloaded) {
      timeline11([
        [selectedSlide, { zIndex: 1 }, { duration: 0 }],
        [selectedSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3 }],
        "content",
        [selectedSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [...getHeadingKeyframe4(selectedSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })],
        [selectedSlide.querySelector(".button"), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [this.querySelector(".slideshow__controls"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }]
      ]);
    }
  }
  _onSlideshowTap(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    event.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  async _transitionTo(fromSlide, toSlide, { direction, animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let timelineControls = null;
    switch (this.transitionType) {
      case "fade":
        timelineControls = this._fade(fromSlide, toSlide, { animate: animate8 });
        break;
      case "fade_with_text":
        timelineControls = this._fadeWithText(fromSlide, toSlide, { animate: animate8 });
        break;
    }
    if (!animate8) {
      timelineControls.finish();
    }
    return timelineControls.finished;
  }
  /**
   * Perform a simple fade transition
   */
  _fade(fromSlide, toSlide) {
    return timeline11([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0.3, at: "<", easing: "ease-out", zIndex: { easing: "step-end" } }]
    ]);
  }
  /**
   * Perform a transition with fade images and image transition
   */
  async _fadeWithText(fromSlide, toSlide) {
    motionAnimate2(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } });
    await imageLoaded4(toSlide.querySelectorAll("img"));
    motionAnimate2(toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0, zIndex: { easing: "step-end" } });
    return timeline11([
      [toSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, easing: "ease-out" }],
      "content",
      [toSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
      [...getHeadingKeyframe4(toSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })]
    ]);
  }
};
if (!window.customElements.get("x-slideshow")) {
  window.customElements.define("x-slideshow", Slideshow);
}
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}


import { animate as motionAnimate3 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { DialogElement, debounce } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var SaveCompare = class extends DialogElement {
  constructor() {
    super();
    const template2 = document.getElementById("modal-default-template").content.cloneNode(true);
    this.attachShadow({ mode: "open" }).appendChild(template2);
    this.shadowRoot.addEventListener("slotchange", (event) => this._updateSlotVisibility(event.target));

    // Variables
    this._compute = this._compute.bind(this);

    this._improve = Number(this.getAttribute("improve"));
    this._retentionPercentage = Number(this.getAttribute("retentionPercentage"));
    this._money = localStorage.getItem("saveCompareMoney") || "";
    this._moneyOption = localStorage.getItem("saveCompareMoneyOption") || "hourly";
    this._hours = localStorage.getItem("saveCompareHours") || "";
    this._chartOption = localStorage.getItem("saveCompareChartOption") || "weekly";

    this._data = {};

    // about form DOM
    this._formDOM = this.querySelector("#saveCompareForm");
    this._formTabsDOM = this._formDOM.querySelectorAll(".money-container.tab-container .tab");

    this._moneyDOM = this._formDOM.querySelector("#saveCompareMoney");
    this._hourDOM = this._formDOM.querySelector("#saveCompareHour");

    // about intro DOM
    this._introDOM = this.querySelector("#saveCompareIntro");
    this._introTabsDOM = this._introDOM.querySelectorAll(".tab-container .tab");

    this._introChartMoneyDOM = this._introDOM.querySelector("#saveCompareChartMoney");
    this._introChartDefaultMoneyDOM = this._introDOM.querySelector("#saveCompareChartDefaultMoney");

    this._introChartChartRateDOM = this._introDOM.querySelector("#saveCompareChartRate");
    this._introChartChartDefaultRateDOM = this._introDOM.querySelector("#saveCompareChartDefaultRate");

  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => this._updateSlotVisibility(slot));

    this._moneyDOM.addEventListener("input", debounce(this._compute, this.autoCompleteDelay));
    this._moneyDOM.value = this._money;

    this._hourDOM.addEventListener("input", debounce(this._compute, this.autoCompleteDelay));
    this._hourDOM.value = this._hours;

    this._formTabsDOM.forEach((tab) => {
      if (tab.dataset.tab === this._moneyOption) {
        tab.classList.add("active");
      }
      tab.addEventListener("click", this._onFormTabClick.bind(this));
    });
    this._introTabsDOM.forEach((tab) => {
      if (tab.dataset.tab === this._chartOption) {
        tab.classList.add("active");
      }
      tab.addEventListener("click", this._onIntroTabClick.bind(this))
    });

    // 监听打开事件
    this.addEventListener("dialog:after-show", this._computeMoney.bind(this));
  }
  _onFormTabClick(event) {
    this._formTabsDOM.forEach((tab) => tab.classList.remove("active"));
    event.target.classList.add("active");

    this._moneyOption = event.target.dataset.tab;
    this._computeMoney();

    localStorage.setItem("saveCompareMoneyOption", this._moneyOption);
  }
  _onIntroTabClick(event) {
    this._introTabsDOM.forEach((tab) => tab.classList.remove("active"));
    event.target.classList.add("active");

    this._chartOption = event.target.dataset.tab;
    this._computeMoney();

    localStorage.setItem("saveCompareChartOption", this._chartOption);
  }
  _compute(event) {
    const target = event.target;
    if (target.value > 0) {
      if (target.id === "saveCompareMoney") {
        this._money = target.value;
        localStorage.setItem("saveCompareMoney", this._money);
      } else {
        this._hours = target.value;
        localStorage.setItem("saveCompareHours", this._hours);
      }
    } else {
      if (target.id === "saveCompareMoney") {
        this._money = "";
        localStorage.setItem("saveCompareMoney", "");
      } else {
        this._hours = "";
        localStorage.setItem("saveCompareHours", "");
      }
    }
    this._computeMoney();
  }
  _computeMoney() {
    let defaultWeekComputeMoney = 0, defaultMonthComputeMoney = 0, defaultYearComputeMoney = 0;
    let weekComputeMoney = 0, monthComputeMoney = 0, yearComputeMoney = 0;
    if (this._money && this._hours) {
      if (this._moneyOption === "hourly") {
        weekComputeMoney = (this._money * this._hours) * this._improve;
        monthComputeMoney = weekComputeMoney * 4;
        yearComputeMoney = monthComputeMoney * 12;

        defaultWeekComputeMoney = (this._money * this._hours);
        defaultMonthComputeMoney = defaultWeekComputeMoney * 4;
        defaultYearComputeMoney = defaultMonthComputeMoney * 12;
      } else {
        weekComputeMoney = (this._money / 12 / 4) * this._improve;
        monthComputeMoney = weekComputeMoney * 4;
        yearComputeMoney = monthComputeMoney * 12;

        defaultWeekComputeMoney = (this._money / 12 / 4);
        defaultMonthComputeMoney = defaultWeekComputeMoney * 4;
        defaultYearComputeMoney = defaultMonthComputeMoney * 12;
      }

      weekComputeMoney = (weekComputeMoney + defaultWeekComputeMoney).toFixed(2);
      monthComputeMoney = (monthComputeMoney + defaultMonthComputeMoney).toFixed(2);
      yearComputeMoney = (yearComputeMoney + defaultYearComputeMoney).toFixed(2);
  
      defaultWeekComputeMoney = defaultWeekComputeMoney.toFixed(2);
      defaultMonthComputeMoney = defaultMonthComputeMoney.toFixed(2);
      defaultYearComputeMoney = defaultYearComputeMoney.toFixed(2);
    }

    this._data = {
      defaultWeekComputeMoney,
      defaultMonthComputeMoney,
      defaultYearComputeMoney,
      weekComputeMoney,
      monthComputeMoney,
      yearComputeMoney,
    };

    this._setChartData();
  }
  _setChartData() {
    let defaultWidth, width, defaultMoney, money;
    if (Object.keys(this._data).length !== 0 && this._data.defaultWeekComputeMoney > 0) {
      const chartRate = (1 - this._retentionPercentage) * 100;
      if (this._chartOption === "weekly") {
        money = this._data.weekComputeMoney;
        defaultMoney = this._data.defaultWeekComputeMoney;
        defaultWidth = (this._data.defaultWeekComputeMoney / this._data.weekComputeMoney) * chartRate;
      } else if (this._chartOption === "monthly") {
        money = this._data.monthComputeMoney;
        defaultMoney = this._data.defaultMonthComputeMoney;
        defaultWidth = (this._data.defaultMonthComputeMoney / this._data.monthComputeMoney) * chartRate;
      } else {
        money = this._data.yearComputeMoney;
        defaultMoney = this._data.defaultYearComputeMoney;
        defaultWidth = (this._data.defaultYearComputeMoney / this._data.yearComputeMoney) * chartRate;
      }

      width = chartRate;
    } else {
      money = "0.00";
      defaultMoney = "0.00";
      width = 0;
      defaultWidth = 0;
    }

    this._introChartChartRateDOM.style.width = width > 0 ? `${width}%` : "1%";
    this._introChartChartDefaultRateDOM.style.width = defaultWidth > 0 ? `${defaultWidth}%` : "1%";
    this._introChartMoneyDOM.textContent = money;
    this._introChartDefaultMoneyDOM.textContent = defaultMoney;
  }
  get autoCompleteDelay() {
    return 280;
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return false;
  }
  get initialFocus() {
    return false;
  }
  _showTransition(animate11 = true) {
    this.style.inset = 0;
    this.style.margin = "auto";
    let animationControls = motionAnimate3(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 });
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    let animationControls = motionAnimate3(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });    
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  _updateSlotVisibility(slot) {
    if (!["header", "footer", "body"].includes(slot.name)) {
      return;
    }
    slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
  }
};
if (!window.customElements.get("save-compare")) {
  window.customElements.define("save-compare", SaveCompare);
}

import { EffectCarousel as EffectCarousel6 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var MPPrdocutFinder = class extends EffectCarousel6 {
  constructor() {
    super();

    this._radios = [];
    this._values = {};

    this._selectedRadio = null;
    this._steps = [];

    this._illustratedDataDOM = null;

    this._carouselPrevDOM = null;
    this._carouselNextDOM = null;

    this._onRadioChange = this._onRadioChange.bind(this);
    this._onCarouselSelect = this._onCarouselSelect.bind(this);    
  }

  connectedCallback() {
    super.connectedCallback();
    this._initializeRadios();
    this._illustratedDataDOM = this.querySelector("#illustrated-data");
    this._carouselPrevDOM = this.querySelector(".carousel__prev");
    this._carouselNextDOM = this.querySelector(".carousel__next");
    this.addEventListener("carousel:select", this._onCarouselSelect);
  }

  _initializeRadios() {
    this._radios = Array.from(this.querySelectorAll("input[type='checkbox']")).filter(radio => radio.classList.contains("illustrated-question__radio"));
    this._radios.forEach(radio => {
      radio.addEventListener("change", this._onRadioChange);
    });
    
    this._steps = this.selectedSlide?.id ? [this.selectedSlide.id] : [];
  }

  _onRadioChange(event) {
    const { target: radio } = event;
    this._updateRadioState(radio);
    this._updateCarouselNextButton(radio);
  }

  _updateRadioState(radio) {
    if (radio.checked) {
      this._values[radio.name] = radio.value;
      this._selectedRadio = radio;
      radio.nextElementSibling.classList.remove("disabled");

      this._radios.filter(r => r.name === radio.name).forEach(r => {
        if (r !== radio) {
          r.checked = false;
          if (!r.nextElementSibling.classList.contains("disabled")) {
            r.nextElementSibling.classList.add("disabled");
          }
        }
      });
    } else {
      delete this._values[radio.name];
      this._selectedRadio = null;
      radio.nextElementSibling.classList.add("disabled");
    }
  }

  _updateCarouselNextButton(radio) {
    this._carouselNextDOM.classList.toggle("enable", radio.checked);
    this._carouselNextDOM.classList.toggle("hidden", !((radio.dataset.next !== '0') || radio.dataset.product));
  }

  _onCarouselSelect(event) {
    if (event.target !== this) return;

    const { index, slide } = event.detail;

    slide.classList.remove("hidden");
    this.items.filter(item => item !== slide).forEach(item => !item.classList.contains("hidden") && item.classList.add("hidden"));

    this._updateCarouselPrevButton(slide, index);
    this._updateCarouselNextButtonState(slide);

    this._updateSteps(slide.id);
  }

  _updateCarouselPrevButton(slide, index) {
    if (slide.id === 'illustrated-data') {
      if (!this._carouselPrevDOM.classList.contains("hidden")) {
        this._carouselPrevDOM.classList.add("hidden");
      }
      return;
    }
    this._carouselPrevDOM.classList.toggle("hidden", index <= 0);
  }

  _updateCarouselNextButtonState(slide) {
    if (slide.id === 'illustrated-data') {
      if (!this._carouselNextDOM.classList.contains("hidden")) {
        this._carouselNextDOM.classList.add("hidden");
      }
      return;
    }
    this._carouselNextDOM.classList.remove("hidden");
    if (this._values[slide.id]) {
      if (!this._carouselNextDOM.classList.contains("enable")) {
        this._carouselNextDOM.classList.add("enable");
      }
      this._selectedRadio = this._radios.find(radio => radio.name === slide.id);
    } else {
      this._carouselNextDOM.classList.remove("enable");
    }
  }

  _updateSteps(id) {
    this._steps = this._steps.slice(0, this._steps.indexOf(id) + 1);
  }

  _getQuestionIdCarouselItemIndex(id) {
    return this.items.findIndex(item => item.id === id);
  }

  _addStep(id) {
    if (!this._steps.includes(id)) {
      this._steps.push(id);
    }
  }

  get loop() {
    return false;
  }

  get previousSlide() {
    return this.items[Math.max(this._getQuestionIdCarouselItemIndex(this._steps[this._steps.length - 2]), 0)];
  }

  get nextSlide() {
    return this.items[Math.max(this._getQuestionIdCarouselItemIndex(this._steps[this._steps.length - 1]), 0)];
  }

  previous(animate = true) {
    this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate });
  }

  next(animate = true) {
    if (!this._selectedRadio) return;

    if (this._selectedRadio.dataset.next === '0') {
      if (!(this._illustratedDataDOM.children.length && this._illustratedDataDOM.querySelector("form").getAttribute('id').includes(this._selectedRadio.dataset.product))) {
        const template = this.querySelector(`#template-product-${this._selectedRadio.dataset.product}`).content.cloneNode(true);
        this._illustratedDataDOM.replaceChildren(template);
      }
      this._addStep('illustrated-data');
      return this.select(this.items.indexOf(this._illustratedDataDOM), { direction: "next", animate: animate });
    }
    this._addStep(this._selectedRadio.dataset.next);
    this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate });
  }
}
if (!window.customElements.get("mp-product-finder")) {
  window.customElements.define("mp-product-finder", MPPrdocutFinder);
}

import { EffectCarousel as EffectCarousel7, fetchCart } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var MPPrdocutFinderV2 = class extends EffectCarousel7 {
  constructor() {
    super();

    this._radios = [];
    this._values = {};

    this._selectedRadio = null;
    this._steps = [];

    this._variantIds = '';
    this._cartVariantKeys = {};
    this._removeToCartHandle = {};

    this._illustratedDataDOM = null;
    this._alsoLikeDOM = null;

    this._carouselBtnsDOM = null;
    this._carouselPrevDOM = null;
    this._carouselNextDOM = null;
    this._carouselCheckoutDOM = null;

    this._cartCountDOM = null;

    this._onRadioChange = this._onRadioChange.bind(this);
    this._onCarouselSelect = this._onCarouselSelect.bind(this);
    this._onCartChangedListener = this._onCartChangedListener.bind(this); 
  }

  connectedCallback() {
    super.connectedCallback();
    this._initializeRadios();
    this._getVariantIds();
    this._getCartItems();

    this._removeToCart = this._removeToCart.bind(this);

    this._illustratedDataDOM = this.querySelector("#illustrated-data");
    this._alsoLikeDOM = this.querySelector("#also-like");
    this._carouselBtnsDOM = this.querySelector(".carousel__btns");
    this._carouselPrevDOM = this.querySelector(".carousel__prev");
    this._carouselNextDOM = this.querySelector(".carousel__next");
    this._carouselCheckoutDOM = this.querySelector(".carousel__checkout");

    this.addEventListener("carousel:select", this._onCarouselSelect);
    document.addEventListener("cart:change", this._onCartChangedListener);
  }

  _initializeRadios() {
    this._radios = Array.from(this.querySelectorAll("input[type='checkbox']")).filter(radio => radio.classList.contains("illustrated-question__radio"));
    this._radios.forEach(radio => {
      radio.addEventListener("change", this._onRadioChange);
    });
    
    this._steps = this.selectedSlide?.id ? [this.selectedSlide.id] : [];
  }

  _getVariantIds() {
    const templates = this.querySelectorAll("template");
    let ids = Array.from(templates).map(template => template.dataset.ids).join(',');
    ids = [...new Set(ids.split(','))].join(',');
    this._variantIds = ids;
  }

  async _getCartItems() {
    const cartItems = (await fetchCart)["items"];
    cartItems.forEach(item => {
      this._cartVariantKeys[item.variant_id] = item.key;
    });
  }

  _onRadioChange(event) {
    const { target: radio } = event;
    //
    if (radio.checked) {
      this._values[radio.name] = radio.value;
      this._selectedRadio = radio;
      radio.nextElementSibling.classList.remove("disabled");

      this._radios.filter(r => r.name === radio.name).forEach(r => {
        if (r !== radio) {
          r.checked = false;
          if (!r.nextElementSibling.classList.contains("disabled")) {
            r.nextElementSibling.classList.add("disabled");
          }
        }
      });
    } else {
      delete this._values[radio.name];
      this._selectedRadio = null;
      radio.nextElementSibling.classList.add("disabled");
    }

    //
    this._carouselNextDOM.classList.toggle("enable", radio.checked);
    this._carouselNextDOM.classList.toggle("hidden", !((radio.dataset.next !== '0') || radio.dataset.product));
  }

  _onCartChangedListener(event) {
    const { cart } = event.detail;

    this._cartVariantKeys = {};
    cart.items.forEach(item => {
      this._cartVariantKeys[item.variant_id] = item.key;
    });

    this._updateCarouselATCButtonState(this.selectedSlide);
    this._updateCarouselCheckoutButtonState(this.selectedSlide);
  }

  _onCarouselSelect(event) {
    if (event.target !== this) return;

    const { index, slide } = event.detail;

    slide.classList.remove("hidden");
    this.items.filter(item => item !== slide).forEach(item => !item.classList.contains("hidden") && item.classList.add("hidden"));

    this._updateCarouselPrevButton(slide, index);
    this._updateCarouselNextButtonState(slide);

    this._updateCarouselATCButtonState(slide);

    this._updateCarouselCheckoutButtonState(slide);
    this._carouselBtnsDOM.classList.toggle("hidden", slide.id === 'illustrated-data');

    this._steps = this._steps.slice(0, this._steps.indexOf(slide.id) + 1);
    this.scrollIntoView({ behavior: "smooth" });
  }

  _updateCarouselATCButtonState(slide) {
    if (slide.id !== 'illustrated-data' && slide.id !== 'also-like' && slide.querySelector("input[type='checkbox']")) {
      return;
    }

    setTimeout(() => {
      const buyButtons = slide.querySelectorAll("button[type='submit']");
      if (buyButtons.length === 0) return;
  
      const addToCartButtons = Array.from(buyButtons).filter(button => !button.hasAttribute("disabled"));
      if (addToCartButtons.length === 0) return;
  
      addToCartButtons.forEach(button => {
        const form = button.closest("form");
        const vid = form.querySelector("input[name='id']").value;
  
        if (this._cartVariantKeys[vid]) {
          if (form.getAttribute('id').includes('only')) {
            if (form.nextElementSibling) {
              form.style.display = "none";
              form.nextElementSibling.style.display = "block";
            }
          }

          button.querySelector('div').textContent = "Remove to cart";
          if (!button.classList.contains("button--subdued")) {
            button.classList.add("button--subdued");
          }
          this._removeToCartHandle[vid] = (e, button, vid, cartVariantKey) => this._removeToCart(e, button, vid, cartVariantKey);
          button.addEventListener("click", (e) => this._removeToCartHandle[vid]?.(e, button, vid, this._cartVariantKeys[vid]));
        } else {
          if (form.getAttribute('id').includes('only')) {
            if (form.nextElementSibling) {
              form.style.display = "block";
              form.nextElementSibling.style.display = "none";
            }
          }

          button.removeAttribute("aria-busy");

          button.querySelector('div').textContent = "Add to cart";
          if (button.classList.contains("button--subdued")) {
            button.classList.remove("button--subdued");
          }
          
          if (this._removeToCartHandle[vid]) {
            button.removeEventListener("click", this._removeToCartHandle[vid]);
            delete this._removeToCartHandle[vid];
          }
        }
      });
    });
  }

  _removeToCart(e, btn, vid, key) {
    e.stopPropagation();
    e.preventDefault();

    if (btn.hasAttribute("aria-busy")) {
      return;
    }

    btn.setAttribute("aria-busy", "true");

    const lineItemQuantity = document.querySelector(`line-item-quantity[data-line-key="${key}"]`);
    lineItemQuantity?._changeLineItemQuantity(key, 0);
  }

  _updateCarouselPrevButton(slide, index) {
    setTimeout(() => {
      if (slide.id === 'illustrated-data') {
        if (!this._carouselPrevDOM.classList.contains("hidden")) {
          this._carouselPrevDOM.classList.add("hidden");
        }
        return;
      }
      this._carouselPrevDOM.classList.toggle("hidden", index <= 0);
    });
  }

  _updateCarouselNextButtonState(slide) {
    setTimeout(() => {
      if (slide.id === 'illustrated-data') {
        if (!this._carouselNextDOM.classList.contains("hidden")) {
          this._carouselNextDOM.classList.add("hidden");
        }
        return;
      }
  
      if (slide.id === 'also-like') {
        if (!this._carouselNextDOM.classList.contains("hidden")) {
          this._carouselNextDOM.classList.add("hidden");
        }
        return;
      }
  
      this._carouselNextDOM.classList.remove("hidden");
      if (this._values[slide.id]) {
        if (!this._carouselNextDOM.classList.contains("enable")) {
          this._carouselNextDOM.classList.add("enable");
        }
        this._selectedRadio = this._radios.find(radio => radio.name === slide.id && radio.value === this._values[slide.id]);        
      } else {
        if (slide.querySelector("input[type='checkbox']")) {
          this._carouselNextDOM.classList.remove("enable");
        } else {
          if (!this._carouselNextDOM.classList.contains("enable")) {
            this._carouselNextDOM.classList.add("enable");
          }
        }
      }
    });
  }

  _updateCarouselCheckoutButtonState(slide) {
    setTimeout(() => {
      const isAlsoLikeSlide = slide.id === 'also-like';
      const isCheckoutButtonHidden = this._carouselCheckoutDOM.classList.contains("hidden");
    
      if (isAlsoLikeSlide && Object.keys(this._cartVariantKeys).length > 0) {
        if (isCheckoutButtonHidden) {
          this._carouselCheckoutDOM.classList.remove("hidden");
        }
      } else {
        if (!isCheckoutButtonHidden) {
          this._carouselCheckoutDOM.classList.add("hidden");
        }
      }
    });
  }

  _getQuestionIdCarouselItemIndex(id) {
    return this.items.findIndex(item => item.id === id);
  }

  _addStep(id) {
    if (!this._steps.includes(id)) {
      this._steps.push(id);
    }
  }

  get loop() {
    return false;
  }

  get previousSlide() {
    return this.items[Math.max(this._getQuestionIdCarouselItemIndex(this._steps[this._steps.length - 2]), 0)];
  }

  get nextSlide() {
    return this.items[Math.max(this._getQuestionIdCarouselItemIndex(this._steps[this._steps.length - 1]), 0)];
  }

  previous(animate = true) {
    this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate });
  }

  next(animate = true) {
    if (!this._selectedRadio) return;

    if (this.selectedSlide.id === 'illustrated-data' || (!this.selectedSlide.querySelector("input[type='checkbox']"))) {
      this._addStep('also-like');
      return this.select(this.items.indexOf(this._alsoLikeDOM), { direction: "next", animate: animate });
    }

    if (this._selectedRadio.dataset.next === '0') {
      const template = this.querySelector(`#template-block-${this._selectedRadio.dataset.block}`)?.content?.cloneNode(true);
      if (!template) return;

      if (this._illustratedDataDOM.dataset.block !== this._selectedRadio.dataset.block) {
        this._illustratedDataDOM.replaceChildren(template);
      }
      this._addStep('illustrated-data');
      return this.select(this.items.indexOf(this._illustratedDataDOM), { direction: "next", animate: animate });
    }
    this._addStep(this._selectedRadio.dataset.next);
    this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate });
  }
}
if (!window.customElements.get("mp-product-finder-v2")) {
  window.customElements.define("mp-product-finder-v2", MPPrdocutFinderV2);
}

import { EffectCarousel as EffectCarousel8, throttle as throttle3, ScrollArea as ScrollAre4 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var UpsellCarousel = class extends EffectCarousel8 {
  connectedCallback() {
    this._hasPendingProgrammaticScroll = false;
    this._scrollArea = new ScrollAre4(this, this._abortController);
    super.connectedCallback();
    
    this.addEventListener("scroll", throttle3(this._onCarouselScroll.bind(this)), { signal: this._abortController.signal });
    this.addEventListener("scrollend", this._onScrollSettled, { signal: this._abortController.signal });
    if (this.autoplay && this._player) {
      ['mouseenter', 'touchstart'].map(event => {
        this.addEventListener(event, () => this._player.pause());
      });
      
      ['mouseleave', 'touchend'].map(event => {
        this.addEventListener(event, () => this._player.resume(true));
      });
    }
  }
  get itemOffset() {
    return this.visibleItems.length < 2 ? 0 : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
  }
  _onCarouselScroll() {
    if (this._hasPendingProgrammaticScroll || this._scrollArea.scrollDirection === "none") {
      return;
    }
    const newIndex = this.items.indexOf(this.visibleItems[Math.round(this.scrollLeft / this.itemOffset)]);
    if (newIndex !== this.selectedIndex) {
      this._selectedIndex = newIndex;
      this._dispatchEvent("carousel:select", this.selectedIndex);
      this._dispatchEvent("carousel:change", this.selectedIndex);
    }
  }
  /**
   * On the scroll has settled we dispatch the event (which covers both programmatic scroll and swipe)
   */
  _onScrollSettled() {
    this.items.forEach((item) => item.classList.remove("is-selected"));
    this.selectedSlide.classList.add("is-selected");
    this._hasPendingProgrammaticScroll = false;
    this._dispatchEvent("carousel:settle", this.selectedIndex);
  }
  /**
     * Transition using the scrollTo method. To prevent the intersection observer to caught up the change, we set up
     * a "hasPendingProgrammaticScroll" variable to true, that is set back to false once the scroll has settled
     */
  _transitionTo(fromSlide, toSlide, { animate: animate11 = true } = {}) {
    if (!toSlide) return;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let slideAlign = this._extractSlideAlign(toSlide), scrollAmount = 0;
    switch (slideAlign) {
      case "start":
        scrollAmount = this.itemOffset * this.visibleItems.indexOf(toSlide);
        break;
      case "center":
        scrollAmount = toSlide.offsetLeft - (this.clientWidth / 2 - (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) + toSlide.clientWidth / 2;
        break;
    }
    this._hasPendingProgrammaticScroll = animate11;
    this.scrollTo({ left: scrollAmount, behavior: animate11 ? "smooth" : "auto" });
  }
  _extractSlideAlign(slide) {
    return getComputedStyle(slide).scrollSnapAlign === "center" ? "center" : "start";
  }
}
if (!window.customElements.get("upsell-carousel")) {
  window.customElements.define("upsell-carousel", UpsellCarousel);
}

class ProductTradeIn extends HTMLElement {
  constructor() {
    super();
    
    this._model = null;
    this._variantId = null;
    this._options = null;

    this._parseOptions = this._parseOptions.bind(this);
    this._addOptionsToSelect = this._addOptionsToSelect.bind(this);
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }

  _parseOptions(input) {
    const delimiter = "@@ ";
    const parts = input.split(delimiter).map(part => part.trim()).filter(part => part);
    if (!input.includes("[")) {
      return parts;
    }

    const options = {};
    let currentKey = null;

    parts.forEach(part => {
      if (part.startsWith("[") && part.endsWith("]")) {
        currentKey = part.slice(1, -1);
        if (!options[currentKey]) {
          options[currentKey] = [];
        }
      } else if (currentKey) {
        options[currentKey].push(part);
      }
    });

    return options;
  }

  _addOptionsToSelect() {
    if (!this._options) return false;
    if (Array.isArray(this._options) && this._tradeInModel.innerHTML !== '') {
      return false;
    }

    this._tradeInModel.innerHTML = '';

    let optionsInnerHTML = `<option value="">Choose your model</option>`;
    if (Array.isArray(this._options)) {
      this._options.forEach(option => {
        optionsInnerHTML += `<option value="${option}">${option}</option>`;
      });
    } else {
      for (const key in this._options) {
        if (key.includes(this._variantId)) {
          this._options[key].forEach(option => {
            optionsInnerHTML += `<option value="${option}">${option}</option>`;
          });
          break;
        }
      }
    }
    this._tradeInModel.innerHTML = optionsInnerHTML;

    return true;
  }

  _onVariantChanged(event) {
    if (!event.detail.variant) return;
    this._variantId = event.detail.variant.id;
    if (this._addOptionsToSelect()) {
      this._tradeInModel.value = '';
      this._tradeInModel.dispatchEvent(new Event('change'));
    }
  }

  connectedCallback() {

    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);

    this._tradeInRadio = this.querySelector('#tradeIn');
    this._noTradeInRadio = this.querySelector('#noTradeIn');
    this._heightWrapper = this.querySelector('[transition-wrapper]');
    this._tradeInModel = this.querySelector('#tradeInModel');

    this._variantId = this.getAttribute('variant-id');
    this._options = this.getAttribute('options') || null;
    if (this._options) {
      this._options = this._parseOptions(this._options);
    }
    this._addOptionsToSelect();

    this._tradeInModel.addEventListener('change', () => {
      this._model = this._tradeInModel.value ? this._tradeInModel.value : null;
    });

    this._tradeInRadio.addEventListener('change', () => {
      if (this._tradeInRadio.checked) {
        const content = this._heightWrapper.querySelector('[transition-height]');
        const contentHeight = content.scrollHeight;
        this._heightWrapper.style.height = `${contentHeight}px`;
      }
    });

    this._noTradeInRadio.addEventListener('change', () => {
      if (this._noTradeInRadio.checked) {
        this._heightWrapper.style.height = '0px';

        this._model = null;
      }
    });
  }

  get model() {
    if (this._model && this._tradeInRadio.checked) {
      return this._model;
    }

    return null;
  }
}

if (!window.customElements.get("product-trade-in")) {
  window.customElements.define("product-trade-in", ProductTradeIn);
}

import { ScrollArea as ScrollArea3 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var PopularBundles = class extends HTMLElement {
  constructor() {
    super();
    this._onDetailsClick = this._onDetailsClick.bind(this);
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  get items() {
    return Array.from(this.children).filter((item) => !item.classList.contains("hidden"));
  }
  connectedCallback() {
    new ScrollArea3(this);
    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);
    this.querySelectorAll('.popular-bundles__product-media, .popular-bundles__wrappe-learnmore').forEach((ele) => {
      ele.addEventListener('click', this._onDetailsClick);
    });
    this._productForm = document.forms[this.getAttribute("form")];
    this._productForm?.addEventListener("variant:change", this._onVariantChangedListener);

    this._controls = this.nextElementSibling;
    this._scrollProgress = this._controls?.querySelector("scroll-progress");
  }
  _prev() {
    this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _next() {
    this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _onDetailsClick(event) {
    const modalID = event.currentTarget.getAttribute('aria-controls');
    if (!modalID) return;
    const modalDOM = document.getElementById(modalID);
    if (!modalDOM) {
      const template = event.currentTarget.closest('.popular-bundles__item-product')?.querySelector('template');
      document.body.appendChild(template.content.cloneNode(true));
    }
  }
  _onVariantChanged(event) {
    if (!event.detail.variant) return;

    let sectionHidden = true;
    let blockShowSize = 0;
    Array.from(this.children).map((item) => {
      const associatedVariants = item.getAttribute("data-associated-variants");
      if (!associatedVariants) {
        sectionHidden = false;
        blockShowSize++;
        return;
      }
      if (associatedVariants.includes(event.detail.variant.id)) {
        sectionHidden = false;
        item.classList.remove("hidden");
        blockShowSize++;
      } else {
        !item.classList.contains("hidden") && item.classList.add("hidden");
      }
    });

    if (sectionHidden) {
      !this.parentNode.classList.contains("hidden") && this.parentNode.classList.add("hidden");
    } else {
      this.parentNode.classList.remove("hidden");
    }

    if (this._controls) {
      if (blockShowSize > 1) {
        this._controls.classList.remove("hidden");
        this._scrollProgress.style.setProperty("--scroll-progress", (1.3 / blockShowSize).toFixed(6));
      } else {
        !this._controls.classList.contains("hidden") && this._controls.classList.add("hidden");
      }
    }
  }
  disconnectedCallback() {
    this.querySelectorAll('.popular-bundles__product-media, .popular-bundles__wrappe-learnmore').forEach((ele) => {
      ele.removeEventListener('click', this._onDetailsClick);
    });
  }
};
if (!window.customElements.get("popular-bundles")) {
  window.customElements.define("popular-bundles", PopularBundles);
}

import { animate as motionAnimate5 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { Drawer as Drawer5 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var PopularBundlesModal = class extends Drawer5 {
  _showTransition(animate11 = true) {
    this.style.inset = 0;
    this.style.margin = "auto";
    let animationControls = motionAnimate5(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 });
    animate11 ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }
  _hideTransition() {
    let animationControls = motionAnimate5(this, { opacity: [1, 0], visibility: ["visibility", "hidden"] }, { duration: 0.2 });    
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  _updateSlotVisibility(slot) {
    if (!["header", "footer", "body"].includes(slot.name)) {
      return;
    }
    slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
  }
};
if (!window.customElements.get("popular-bundles-modal")) {
  window.customElements.define("popular-bundles-modal", PopularBundlesModal);
}

import { EffectCarousel as EffectCarousel9 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var PopularBundlesCarousel = class extends EffectCarousel9 {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
  }

  get shouldAppendToBody() {
    return true;
  }
}
if (!window.customElements.get("popular-bundles-carousel")) {
  window.customElements.define("popular-bundles-carousel", PopularBundlesCarousel);
}

// import { timeline as timeline12, inView as inView11 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
// import { imageLoaded as imageLoaded5, getHeadingKeyframe as getHeadingKeyframe5 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
// var MPFigure = class extends HTMLElement {
//   connectedCallback() {
//     inView11(this, async () => {
//       await imageLoaded5(Array.from(this.querySelectorAll(":is(img, svg)")));
//       const headings = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
//       timeline12([
//         [this, { opacity: [0, 1] }, { duration: 0.25 }],
//         ...headings.map((heading) => [...getHeadingKeyframe5(heading)])
//       ]);
//     });
//   }
// };
// if (!window.customElements.get("mp-figure")) {
//   window.customElements.define("mp-figure", MPFigure);
// }

var EasterEggHuntForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit);
  }

  connectedCallback() {
    this.errorBanner = this.querySelector(".easter-egghunt-form__error");
  }

  async _onSubmit(event) {
    event.preventDefault();

    !this.errorBanner.classList.contains("hidden") && this.errorBanner.classList.add("hidden");

    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });

    const formData = new FormData(this);
    const secret = formData.get("secret");
    const hash = await this.generateHash(secret.trim().toLowerCase());

    const ok = hash === "798247de91e37d04ac6a4a549489b11e027b34cf77b53445a3fcf865b1b56e67";
    await this.push(ok, formData);

    if (!ok) {
      this.errorBanner.classList.remove("hidden");
    }

    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });

    if (ok) {
      window.location.href = 'https://everypixeltellsastory.xyz';
    }
  }

  async generateHash(text) {
    // Convert the input text to a Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(text);

    // Compute the hash (SHA-256)
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);

    // Convert the ArrayBuffer to a hexadecimal string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, "0")).join("");
    
    return hashHex;
  }

  async push(ok, formData) {
    const body = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              meta: {
                patch_properties: {
                  append: {
                    "Easter Egghunt Secret": formData.get('secret').trim().toUpperCase(),
                    "Easter Egghunt Project": formData.get('projects'),
                  }
                }
              },
              subscriptions: {
                email: {
                  marketing: {
                    consent: "SUBSCRIBED"
                  }
                },
              },
              attributes: {
                first_name: formData.get('first_name'),
                last_name: formData.get('last_name'),
                email: formData.get('email'),
              }
            }
          },
          custom_source: "Easter Egghunt From"
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "Rs8peu"
            }
          }
        }
      }
    };

    if (!ok) {
      // delete body.data.attributes.profile.data.meta;
      body.data.attributes.profile.data.meta = {
        patch_properties: {
          append: {
            "Easter Egghunt Failed Secret": formData.get('secret').trim(),
          }
        }
      };
    }

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(body),
    };
  
    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=YiT4Tu', options);
    if (!response.ok) {
      // console.error(response);
    }
    console.error(response);
  }
  
}
if (!window.customElements.get("easter-egghunt-form")) {
  window.customElements.define("easter-egghunt-form", EasterEggHuntForm, { extends: "form" });
}

import { Delegate as Delegate3 } from "//www.mobilepixels.us/cdn/shop/t/265/assets/vendor.min.js?v=20880576495916334881692795072";
import { ProductLoader, formatMoney, AjaxCart } from "//www.mobilepixels.us/cdn/shop/t/265/assets/theme.js?v=70348070209927941751745308334";
var CartDrawerUpsells = class extends HTMLElement {
  constructor() {
    super();
    this._controls = null;
    this._onAddToCart = this._addToCart.bind(this);
  }

  connectedCallback() {
    this._controls = this.querySelector(".cart-drawer__upsells_controls");
    this.load();
  }

  async load() {
    if (!this.handles.length) return;

    const results = await Promise.allSettled(this.handles.map(handle => ProductLoader.load(handle)));

    const template = this.querySelector("template").content.cloneNode(true);
    const horizontalProductDOM = template.querySelectorAll(".horizontal-product");

    let count = 0;
    for (let i = 0; i < horizontalProductDOM.length; i++) {
      if (results[i].status !== 'fulfilled') {
        horizontalProductDOM[i].remove();
        continue;
      }

      const { available, price, compare_at_price, title, url, featured_image, id } = results[i].value;

      if (!available) {
        horizontalProductDOM[i].remove();
        continue;
      }

      const productDOM = horizontalProductDOM[i];
      const titleDOM = productDOM.querySelector(".horizontal-product__title");
      const imageDOM = productDOM.querySelector(".horizontal-product__image");
      const urlDOM = productDOM.querySelector(".horizontal-product__url");
      const priceDOM = productDOM.querySelector(".horizontal-product__price");
      const compareAtPriceDOM = productDOM.querySelector(".horizontal-product__compareAtPrice");
      const offDOM = productDOM.querySelector(".horizontal-product__off");
      const addToCartDOM = productDOM.querySelector("button");

      // Update the product details
      titleDOM.innerHTML = title;
      imageDOM.src = featured_image, imageDOM.alt = title;
      urlDOM.href = url;
      priceDOM.innerHTML = formatMoney(price);

      if (compare_at_price && compare_at_price > price) {
        compareAtPriceDOM.innerHTML = formatMoney(compare_at_price);
        compareAtPriceDOM.classList.remove("hidden");

        const discount = (compare_at_price - price) * 1.0;

        let discountText = "";
        if (discount > 2000) {
          discountText = `Saved ${formatMoney(discount)}`;
        } else {
          // OFF
          discountText = `${Math.round(Math.abs((price / compare_at_price - 1) * 100))}% OFF`;
        }

        offDOM.innerHTML = discountText;
        offDOM.classList.remove("hidden");
      }

      const delegate = new Delegate3(addToCartDOM);
      delegate.on("click", "button", (e, target) => {
        this._onAddToCart(target, id, i);
      });

      count++;
    }

    if (count <= 0) {
      this.remove();
      return;
    }

    this.querySelector('.cart-drawer__upsells_container').append(template);
  }

  _addToCart(target, id, i) {
    if (target.hasAttribute('aria-busy') && target.getAttribute('aria-busy') == 'true') {
      return;
    }
    target.setAttribute('aria-busy', 'true');
    window.fetchWarrantyOptions(id, this.vids[i]).then(() => {
      AjaxCart.add([{ id: this.vids[i], quantity: 1 }]).then(res => {
        res.event();
        target?.removeAttribute('aria-busy');
        const horizontalProducts = this.querySelectorAll(".horizontal-product");
        if (horizontalProducts.length <= 1) {
          this.remove();
        } else {
          if (horizontalProducts.length === 2) {
            this._controls.style.display = "none";
          }
          target.closest(".horizontal-product").remove();
        }
      }).catch(err => {
        target?.removeAttribute('aria-busy');
      });
    });
  }

  get vids() {
    return this.getAttribute("vids").split(",");
  }

  get handles() {
    return this.getAttribute("handles").split("@@@");
  }

}
if (!window.customElements.get("cart-drawer-upsells")) {
  window.customElements.define("cart-drawer-upsells", CartDrawerUpsells);
}